<script>
    import { onMount } from 'svelte';
  
    let address = '';
    let transactions = [];
    let errorMessage = '';
    let isLoading = false;
  
    async function fetchTransactions(address) {
      const base_url = "https://glacier-api.avax.network";
      const chain_id = 43114;
      let page_token = null;
      const endpoint = `${base_url}/v1/chains/${chain_id}/addresses/${address}/transactions:listErc20`;
      transactions = []; // Reset transactions
      errorMessage = '';
      isLoading = true;
  
      try {
        while (true) {
          const params = new URLSearchParams({
            pageSize: 100,
            startBlock: 39000000
          });
          if (page_token !== null) {
            params.append('pageToken', page_token);
          }
  
          const response = await fetch(`${endpoint}?${params}`);
          if (!response.ok) throw new Error(`API request failed with status code ${response.status}`);
  
          const data = await response.json();
          transactions.push(...data.transactions);
  
          if (!data.nextPageToken) break;
          page_token = data.nextPageToken;
        }
      } catch (error) {
        errorMessage = error.message;
      } finally {
        isLoading = false;
      }
    }
  
    function handleSubmit() {
      fetchTransactions(address);
    }
  
    function snowTraceUrl(address) {
      return `https://snowtrace.io/address/${address}`;
    }
  
    function formatDate(timestamp) {
      return new Date(timestamp * 1000).toLocaleString();
    }
  </script>
  
  <style>
    .transaction {
      border: 1px solid #ddd;
      padding: 10px;
      margin-bottom: 10px;
      border-radius: 5px;
    }
  
    .transaction-header {
      font-weight: bold;
    }
  
    .transaction-detail {
      margin: 5px 0;
    }
  
    .addresses {
      display: flex;
      justify-content: space-between;
    }
  
    a {
      text-decoration: none;
      color: blue;
    }
  </style>
  
  <form on:submit|preventDefault={handleSubmit}>
    <input type="text" bind:value={address} placeholder="Enter address" />
    <button type="submit">Submit</button>
  </form>
  
  {#if isLoading}
  <div>Loading...</div>
{:else if transactions.length}
  <div>
    {#each transactions as transaction}
      <div class="transaction">
        <div class="transaction-header">Transaction Details</div>
        <div class="addresses">
          <span>From: <a href={snowTraceUrl(transaction.from.address)} target="_blank">{transaction.from.address}</a></span>
          <span>To: <a href={snowTraceUrl(transaction.to.address)} target="_blank">{transaction.to.address}</a></span>
        </div>
        <div class="transaction-detail">Block Number: {transaction.blockNumber}</div>
        <div class="transaction-detail">Block Hash: {transaction.blockHash}</div>
        <div class="transaction-detail">Transaction Hash: <a href={`https://snowtrace.io/tx/${transaction.txHash}`} target="_blank">{transaction.txHash}</a></div>
        <div class="transaction-detail">Date: {formatDate(transaction.blockTimestamp)}</div>
        <div class="transaction-detail">Token Name: {transaction.erc20Token.name} ({transaction.erc20Token.symbol})</div>
        <div class="transaction-detail">Value: {transaction.value / (10 ** transaction.erc20Token.decimals).toFixed(2)}</div>
        {#if transaction.erc20Token.price && transaction.erc20Token.price.value !== undefined}
          <div class="transaction-detail">Token Price: ${transaction.erc20Token.price.value.toFixed(6)} {transaction.erc20Token.price.currencyCode}</div>
        {/if}
      </div>
    {/each}
  </div>
{:else if errorMessage}
  <div class="error">{errorMessage}</div>
{/if}

  